module.exports = __webpack_public_path__ + "static/media/WhatsappRounded.831d9918.svg";